var React = require('react');

function OmbreMEUF (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #6fa5c9;\n        opacity: 0.5;\n      }\n    ")),React.createElement("ellipse",{"id":"ombreMEUF","className":"cls-1","cx":"69.5","cy":"4.5","rx":"69.5","ry":"4.5","key":1})]);
}

OmbreMEUF.defaultProps = {"width":"139","height":"9","viewBox":"0 0 139 9"};

module.exports = OmbreMEUF;

OmbreMEUF.default = OmbreMEUF;
